<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Novo usuário"
      Pagina="Novo"
      [TemPaginaPai] = true
      LinkPaginaPai="/auth/usuario"
      PaginaPai="Usuário"
    ></app-breadcrumb>
    <div class="row" style="width: 101%">
      <div class="col-md-12">
        <div class="card card-blue">
          <form [formGroup]="formCadastrar" id="formCadastrar">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="nome">Nome:</label>
                    <input type="text" id="nome" formControlName="nome" class="form-control">
                    <span id="nome-error-required" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['nome'].touched
                          && formCadastrar.controls['nome'].errors?.required"
                    >O nome não pode ser vazio <br></span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="email">Email:</label>
                    <input type="email" id="email" formControlName="email" class="form-control">
                    <span id="email-error-required" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['email'].touched && formCadastrar.controls['email'].errors?.required"
                    >O email não pode ser vazio <br></span>
                    <span id="nome-error-min-length" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['email'].touched
                          && formCadastrar.controls['email'].errors?.email"
                    >Email com formato inválido.<br></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="senha">Senha:</label>
                    <input type="password" id="Senha" formControlName="senha" class="form-control">
                    <span id="senha-error-required" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['senha'].touched
                          && formCadastrar.controls['senha'].errors?.required"
                    >A senha não pode ser vazio <br></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="confirmacaoSenha">Confirmação de senha:</label>
                    <input type="password" id="confirmacaoSenha" formControlName="confirmacaoSenha" class="form-control">
                    <span id="confirmacaoSenha-error-required" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['confirmacaoSenha'].touched
                          && formCadastrar.controls['confirmacaoSenha'].errors?.required"
                    >A senha não pode ser vazio <br></span>
                    <span id="confirmacaoSenha-error-equals" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['confirmacaoSenha'].touched
                          && formCadastrar.controls['confirmacaoSenha'].value != formCadastrar.controls['senha'].value"
                    >As senhas estão diferentes <br></span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="tipo">Tipo:</label>
                    <ng-select
                      id= "tipo"
                      [items]="listaTipoUsuario"
                      bindLabel="descricao"
                      bindValue="id"
                      formControlName="tipo">
                    </ng-select>
                    <span id="tipo-error-required" class="error mensagem-erro"
                          *ngIf="formCadastrar.controls['tipo'].touched
                          && formCadastrar.controls['tipo'].errors?.required"
                    >O tipo de usuário não pode ser vazio <br></span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <button (click)="voltar()" class="col-md-4 btn btn-warning">Voltar</button>
                </div>
                <div class="col-md-6 text-right">
                  <button (click)="salvar()" class="col-md-4 btn btn-success">Salvar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
